import { Oval } from 'react-loader-spinner';
import { useTheme } from '../../providers/theme';
import { useTranslation } from 'react-i18next';

type LoadingScreenProps = {
  isVisible: boolean;
}

export function LoadingScreen({ isVisible }: LoadingScreenProps) {
  const { theme } = useTheme();
  const {t} = useTranslation();
  return (
    <>
      {isVisible ? (
        <div style={{ height: '100vh', width: '100vw', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 20 }}>
          <Oval color={theme.colors.main} secondaryColor={theme.colors.hoverMain} height='50px' />
          <span>{t('loading')}</span>
        </div>
      ) : null}
    </>
  );
}
